module.exports = __webpack_public_path__ + "static/media/lk_parking_icon.580c703c.png";